/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  ContextMenuTrigger
} from 'react-contextmenu';
import { connect } from 'react-redux';
import { sortData } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';
import { selectIsFetching, selectTemplatesSelected, vulnTemplatesList } from 'store/KnowledgeBase/selectors';
import getColumns from './Columns';
import { FormattedMessage } from 'react-intl';
import { selectFields } from 'store/Preferences/knowledgeBase/selectors';
import useTheme from 'Hooks/UseTheme';
import { KbCustomReactTable, KbTableContainer } from './styled';

class Table extends Component {
  constructor (props) {
    super(props);
    this.table = React.createRef();
    this.state = {
      tableWidth: 0
    };
    this.fetchData = this.fetchData.bind(this);
    this.getTrProps = this.getTrProps.bind(this);
    this.updateTableWidth = this.updateTableWidth.bind(this);
  }

  componentDidMount () {
    this.updateTableWidth();
    window.addEventListener('resize', this.updateTableWidth);
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateTableWidth);
  }

  componentDidUpdate (prevProps) {
    if (
      prevProps.isFetching !== this.props.isFetching ||
      prevProps.data.length !== this.props.data.length ||
      prevProps.fields !== this.props.fields
    ) {
      this.updateTableWidth();
    }
  }

  updateTableWidth () {
    if (!this.table) return;
    const nextWidth = Math.floor(this.table.clientWidth || 0);
    if (nextWidth && nextWidth !== this.state.tableWidth) {
      this.setState({ tableWidth: nextWidth });
    }
  }

  getTrProps (theme, state, rowInfo) {
    const selected = this.props.templatesSelected.filter((x) => x.id === rowInfo.original.id).length > 0;

    return {
      style: {
        background: selected ? `${theme.themeStyles.backgrounds.selectedTableItem}` : ''
      }
    };
  }

  fetchData (state) {
    const {
      isFetching
    } = this.props;

    if (!isFetching) {
      this.props.sortData(state.sorted);
    }
  }

  render () {
    const {
      data,
      isFetching,
      fields
    } = this.props;
    const { tableWidth } = this.state;

    const mockData = [...Array(13).keys()];

    return (
      <KbTableContainer ref={ (element) => { this.table = element; } }>
        <ContextMenuTrigger id="massive_update_kb_table" holdToDisplay={ 1000000 }>
          <KbCustomReactTable
            data={ isFetching ? mockData : data }
            columns={ getColumns(isFetching, fields, tableWidth) }
            minRows={ 0 }
            page={ 1 }
            manual
            onFetchData={ this.fetchData }
            getTrProps={ (state, rowInfo) => this.getTrProps(this.props.theme, state, rowInfo) }
            showPagination={ false }
            noDataText={ !isFetching && <FormattedMessage id="app.nodata.context" /> }
          />
        </ContextMenuTrigger>
      </KbTableContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  data: vulnTemplatesList(state),
  isFetching: selectIsFetching(state),
  templatesSelected: selectTemplatesSelected(state),
  fields: selectFields(state)
});

const mapDispatchToProps = (dispatch) => ({
  sortData: (sorting) => {
    dispatch(sortData(sorting));
  }
});

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  isFetching: PropTypes.bool.isRequired,
  sortData: PropTypes.func.isRequired,
  templatesSelected: PropTypes.arrayOf(PropTypes.object).isRequired
};

const ThemedTable = (props) => {
  const theme = useTheme(); // Get the theme using the hook
  return <Table { ...props } theme={ theme } />;
};

export default connect(mapStateToProps, mapDispatchToProps)(ThemedTable);
